import React from 'react'
export const UpsideDownVImg = () => {
  return (
        <svg xmlns="http://www.w3.org/2000/svg" width="291" height="295" viewBox="0 0 291 290" fill="none">
        <path d="M279.229 278.311L140.575 2.29883L1.92163 278.311M202.464 278.311L140.911 156.154L79.3588 278.311" stroke="black" strokeWidth="3.38726" strokeLinejoin="round"/>
        </svg>
  )
}
